import { z } from 'zod';

import { uuidValidator } from '../../validators';
import { CompareWordsResponseSchema } from '../gemini';
import { WordResponseSchema } from '../words';

export const WordComparisonResponseSchema = z.object({
  customNotes: z.string().nullable().optional(),
  difference: CompareWordsResponseSchema.shape.difference,
  id: uuidValidator,
  languages: CompareWordsResponseSchema.shape.languages,
  userId: uuidValidator,

  wordDetails: CompareWordsResponseSchema.shape.wordDetails,
  wordIds: z.array(uuidValidator),
  words: z.array(WordResponseSchema).optional(),
});

export type IWordComparisonResponseDto = z.infer<
  typeof WordComparisonResponseSchema
>;
